import { render, staticRenderFns } from "./InvitationDeleter.vue?vue&type=template&id=4532af8a"
import script from "./InvitationDeleter.vue?vue&type=script&lang=js"
export * from "./InvitationDeleter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports